module.exports = "<div [class]=\"'custom-close custom-close-' + variant\">\n  <span [class]=\"'custom-cross custom-cross-' + variant\"></span>\n</div>\n"